export const hotels = [
  {
    id: "tulia",
    title: "Tulia Zanzibar Unique Beach Resort",
    location: "Pongwe",
    shortDescription: "Luxury beachfront resort with pools and private beach.",
    longDescription: `Tulia Zanzibar Unique Beach Resort is a five-star property located on the tranquil Pongwe coast. 
Guests are welcomed into spacious villas with private terraces, lush gardens, and direct access to the beach. 
The resort features two swimming pools, including one overlooking the ocean, and a private stretch of white sand. 
Dining is a highlight, with chefs preparing gourmet meals that blend international flavors with fresh local ingredients. 
The spa offers rejuvenating treatments inspired by Swahili traditions, while yoga sessions on the beach provide relaxation. 
Activities include snorkeling, diving, and cultural excursions to nearby villages. 
Families appreciate the child-friendly amenities, while couples enjoy romantic sunset dinners. 
Sustainability is a core value, with eco-friendly practices integrated into daily operations. 
Tulia combines luxury, culture, and nature, making it one of Zanzibar’s most exclusive escapes.`,
    image: "/images/tulia.jpg",
    cta: { label: "Read More", href: "/hotels/tulia" },
    type: "hotels", // for CardGrid linking
    rating: 5
  },
  {
    id: "gold-zanzibar",
    title: "Gold Zanzibar Beach House & Spa",
    location: "Nungwi",
    shortDescription: "Stylish rooms with terraces overlooking the Indian Ocean.",
    longDescription: `Gold Zanzibar Beach House & Spa is located on the famous Nungwi Beach, offering breathtaking views of the Indian Ocean. 
The resort features elegantly designed rooms and suites, each with private terraces or verandas. 
Guests can indulge in spa treatments that combine African and Asian techniques, or relax by the infinity pool. 
Dining options include beachfront restaurants serving fresh seafood, Italian specialties, and Swahili-inspired dishes. 
The resort organizes water sports such as diving, snorkeling, and deep-sea fishing. 
Evening entertainment includes live music and cultural performances. 
Gold Zanzibar is ideal for travelers seeking a blend of style, comfort, and adventure, with personalized service ensuring every stay is memorable.`,
    image: "/images/goldhouse.webp",
    cta: { label: "Read More", href: "/hotels/gold-zanzibar" },
    type: "hotels",
    rating: 5
  },
  {
    id: "white-sand",
    title: "Zanzibar White Sand Luxury Villas & Spa",
    location: "Paje",
    shortDescription: "Luxury villas, spa and beachfront dining.",
    longDescription: `Zanzibar White Sand Luxury Villas & Spa is a Relais & Châteaux property located on Paje Beach. 
Each villa offers private pools, spacious living areas, and direct beach access. 
The resort’s spa is set in a tropical garden, offering massages, hammam rituals, and wellness therapies. 
Dining is exceptional, with beachfront restaurants serving gourmet cuisine and fresh seafood. 
Guests can enjoy kite surfing, snorkeling, and excursions to nearby islands. 
Sustainability is central, with solar energy, organic gardens, and eco-friendly construction. 
White Sand is perfect for couples seeking romance, families wanting privacy, and travelers looking for barefoot luxury. 
The combination of exclusivity, natural beauty, and world-class service makes it one of Zanzibar’s finest resorts.`,
    image: "/images/whitesand.webp",
    cta: { label: "Read More", href: "/hotels/white-sand" },
    type: "hotels",
    rating: 5
  },
  {
    id: "forodhani",
    title: "Forodhani Park Hotel",
    location: "Stone Town",
    shortDescription: "Central budget-friendly hotel.",
    longDescription: `Forodhani Park Hotel is located in the heart of Stone Town, just steps from the famous Forodhani Gardens. 
The hotel offers affordable rooms with modern amenities, making it ideal for budget-conscious travelers. 
Guests enjoy easy access to Stone Town’s historic sites, markets, and waterfront. 
The rooftop terrace provides panoramic views of the city and ocean, perfect for sunset relaxation. 
Breakfast is included, with local and continental options available. 
The hotel staff are known for their warm hospitality and helpful travel advice. 
Forodhani Park Hotel is a convenient base for exploring Zanzibar’s culture and history without compromising comfort.`,
    image: "/images/foroparkhotel.jpg",
    cta: { label: "Read More", href: "/hotels/forodhani" },
    type: "hotels",
    rating: 4
  },
  {
    id: "kisiwa",
    title: "Kisiwa House Hotel",
    location: "Stone Town",
    shortDescription: "Historic boutique stay.",
    longDescription: `Kisiwa House Hotel is a historic boutique property in Stone Town, blending Swahili architecture with modern luxury. 
Originally built in the 19th century, the hotel has been carefully restored to preserve its heritage. 
Rooms feature carved wooden furniture, high ceilings, and elegant decor. 
Guests can dine at the rooftop restaurant, which offers panoramic views of Stone Town and the ocean. 
The hotel is within walking distance of major attractions such as the House of Wonders and the Old Fort. 
Personalized service ensures a memorable stay, with staff arranging guided tours, cultural experiences, and excursions. 
Kisiwa House is ideal for travelers seeking history, charm, and comfort in the heart of Zanzibar.`,
    image: "/images/kisiwahouse.avif",
    cta: { label: "Read More", href: "/hotels/kisiwa" },
    type: "hotels",
    rating: 4
  }
];
